import { Navigation } from "lucide-react";

import { Resource } from "@/types/supabase";

export interface ResourcesProps {
  resources: Resource[];
}

const Resources = ({ resources = [] }: ResourcesProps) => {
  return (
    <div className="space-y-3">
      {resources.length > 0 && (
        <div className="space-y-3">
          {resources.map((resource, index) => (
            <div
              key={`resource-${resource.name}-${index}`}
              className="flex cursor-pointer items-stretch overflow-hidden rounded-lg bg-gray-50"
              onClick={() => {
                if (resource.link) window.open(resource.link, "_blank");
              }}
            >
              <div className="flex w-10 items-center justify-center bg-amber-200">
                <Navigation className="size-5 text-amber-800" />
              </div>
              <div className="flex-1 p-3">
                <div className="text-sm font-bold">{resource.type}:</div>
                <div className="text-sm">{resource.name}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Resources;
